/** Namespace `appointments` (inkl. .modal/.form) — befüllt während der Migration. */
export const appointments = {
  de: {
    appointments: {
      page: {
        eyebrow: 'Übersicht',
        title: 'Termine',
        description: 'Alle Termine durchsuchen und filtern',
        loadError: 'Daten konnten nicht geladen werden',
        of: 'von',
        searchLabel: 'Suche (Name oder E-Mail)',
        searchPlaceholder: 'z. B. Müller oder @example.com',
        from: 'Von',
        to: 'Bis',
        resetFilters: 'Filter zurücksetzen',
        loading: 'Lade…',
        emptyHitsTitle: 'Keine Treffer',
        emptyTitle: 'Noch keine Termine',
        emptyHitsDescription: 'Keine Termine entsprechen den aktuellen Filtern.',
        emptyDescription: 'Sobald Termine vereinbart werden, erscheinen sie hier.',
        colDateTime: 'Datum / Zeit',
        room: 'Raum',
        inCalendar: 'Im Kalender',
        statusPendingWebsite: 'Offen (Website)',
        statusScheduled: 'Geplant',
        statusConfirmed: 'Bestätigt',
        statusCompleted: 'Abgeschlossen',
        statusCancelled: 'Storniert',
        statusNoShow: 'Nicht erschienen',
      },
      modal: {
        loadHistoryError: 'Historie konnte nicht geladen werden',
        actionCreate: 'Termin erstellt',
        actionUpdate: 'Termin aktualisiert',
        actionCancel: 'Termin storniert',
        actionDelete: 'Termin gelöscht',
        actionEmailSent: 'E-Mail versendet ({{type}})',
        actionEmailFailed: 'E-Mail-Versand fehlgeschlagen',
        actionInvoiceFinalized: 'Rechnung ausgestellt ({{num}})',
        actionOfferFinalized: 'Angebot ausgestellt ({{num}})',
        actionCancellationFinalized: 'Stornorechnung ausgestellt ({{num}})',
        actionInvoicePaid: 'Rechnung als bezahlt markiert ({{num}})',
        actionInvoiceCanceled: 'Rechnung storniert ({{num}})',
        actionCancellationIssued: 'Stornorechnung ausgestellt ({{num}})',
        actionInvoiceEmailed: 'Beleg per E-Mail versendet ({{num}} an {{to}})',
        actionInvoiceEmailFailed: 'E-Mail-Versand für {{num}} fehlgeschlagen',
        cancelledToast: 'Termin storniert & E-Mail gesendet!',
        confirmedToast: 'Termin bestätigt & E-Mail gesendet!',
        statusUpdatedToast: 'Terminstatus aktualisiert auf {{status}}',
        updateError: 'Termin konnte nicht aktualisiert werden',
        confirmDelete: 'Sind Sie sicher, dass Sie diesen Termin löschen möchten?',
        deleteError: 'Termin konnte nicht gelöscht werden',
        intakeLinkCopied: 'Erfassungsbogen-Link kopiert',
        intakeLinkCopyError: 'Konnte Link nicht kopieren',
        statusPending: 'Offen',
        statusConfirmed: 'Bestätigt',
        statusScheduled: 'Geplant',
        statusCompleted: 'Abgeschlossen',
        statusCancelled: 'Storniert',
        statusNoShow: 'Nicht erschienen',
        title: 'Termin-Details',
        tabDetails: 'Details',
        tabIntake: 'Erhebungsbogen',
        intakeSubmittedLabel: 'ausgefüllt',
        tabHistory: 'Historie',
        intakeBannerTitle: 'Erfassungsbogen für den Patienten',
        intakeSubmittedBadge: '✓ Bogen ausgefüllt',
        intakeWaitingBadge: 'Wartet auf Patient',
        intakeBannerText:
          'Termin ist bestätigt. Die Anamnese-Erhebung ist berufsrechtliche Pflicht — die digitale Vorab-Erfassung ist für den Patienten bequem und spart am Behandlungstag Wartezeit.',
        copyLink: 'Link kopieren',
        copied: 'Kopiert!',
        openForm: 'Bogen öffnen',
        sendMailToPatient: 'Mail an Patient senden →',
        websiteBannerTitle: 'Online-Buchung von seadent.es',
        websiteBannerPending:
          'Patient hat über das Booking-Formular gebucht. Bitte bestätigen oder ablehnen.',
        websiteBannerOther: 'Diese Buchung kam ursprünglich über die Website.',
        insuranceLabel: 'Versicherung (Patient-Angabe):',
        patientInfo: 'Patient-Informationen',
        name: 'Name:',
        email: 'E-Mail:',
        phone: 'Telefon:',
        appointmentDetails: 'Termin-Details',
        date: 'Datum:',
        time: 'Zeit:',
        provider: 'Behandler:',
        procedure: 'Behandlung:',
        operatory: 'Raum:',
        status: 'Status:',
        notes: 'Notizen',
        googleCalendar: 'Google Calendar',
        viewInGoogleCalendar: 'In Google Calendar ansehen',
        edit: 'Bearbeiten',
        completeAndInvoice: 'Abschließen & Rechnung',
        createOffer: 'Angebot erstellen',
        createInvoice: 'Rechnung erstellen',
        acceptScheduled: 'Annehmen (→ Geplant)',
        confirm: 'Bestätigen',
        complete: 'Abschließen',
        cancel: 'Stornieren',
        noShow: 'Nicht erschienen',
        delete: 'Löschen',
        loadingHistory: 'Historie wird geladen…',
        noHistory: 'Keine Historie gefunden.',
        historyBy: 'durch {{user}}',
      },
      form: {
        fillRequired: 'Bitte füllen Sie alle Pflichtfelder aus',
        patientNamePlaceholder: 'Max Mustermann',
        emailLabel: 'E-Mail *',
        emailPlaceholder: 'max@example.com',
        phoneLabel: 'Telefon *',
        phonePlaceholder: '+34-612-345678',
        langEnglish: 'English',
        langGerman: 'Deutsch',
        langSpanish: 'Español',
        langRussian: 'Русский',
        selectProvider: 'Behandler wählen',
        selectProcedure: 'Behandlung wählen',
        selectOperatory: 'Raum wählen',
        startTime: 'Startzeit *',
        endTime: 'Endzeit *',
        googleCalendarTarget: '📅 Google-Kalender für diesen Termin',
        mainCalendar: 'Hauptkalender',
        defaultTag: '(Standard)',
        previousCalendar: 'Bisheriger Kalender',
        targetLockedHint:
          'ℹ️ Kalender-Zuordnung kann nach Erstellung nicht mehr geändert werden.',
        notesPlaceholder: 'Zusätzliche Notizen…',
        fallbackPrimaryLabel: 'Bisheriger Kalender',
      },
    },
  },
  es: {
    appointments: {
      page: {
        eyebrow: 'Resumen',
        title: 'Citas',
        description: 'Buscar y filtrar todas las citas',
        loadError: 'No se pudieron cargar los datos',
        of: 'de',
        searchLabel: 'Búsqueda (nombre o correo electrónico)',
        searchPlaceholder: 'p. ej., Müller o @example.com',
        from: 'Desde',
        to: 'Hasta',
        resetFilters: 'Restablecer filtros',
        loading: 'Cargando…',
        emptyHitsTitle: 'Sin resultados',
        emptyTitle: 'Aún no hay citas',
        emptyHitsDescription: 'Ninguna cita coincide con los filtros actuales.',
        emptyDescription: 'En cuanto se concierten citas, aparecerán aquí.',
        colDateTime: 'Fecha / Hora',
        room: 'Sala',
        inCalendar: 'En el calendario',
        statusPendingWebsite: 'Pendiente (sitio web)',
        statusScheduled: 'Programada',
        statusConfirmed: 'Confirmada',
        statusCompleted: 'Completada',
        statusCancelled: 'Cancelada',
        statusNoShow: 'No asistió',
      },
      modal: {
        loadHistoryError: 'No se pudo cargar el historial',
        actionCreate: 'Cita creada',
        actionUpdate: 'Cita actualizada',
        actionCancel: 'Cita cancelada',
        actionDelete: 'Cita eliminada',
        actionEmailSent: 'Correo enviado ({{type}})',
        actionEmailFailed: 'Error al enviar el correo',
        actionInvoiceFinalized: 'Factura emitida ({{num}})',
        actionOfferFinalized: 'Presupuesto emitido ({{num}})',
        actionCancellationFinalized: 'Factura de anulación emitida ({{num}})',
        actionInvoicePaid: 'Factura marcada como pagada ({{num}})',
        actionInvoiceCanceled: 'Factura anulada ({{num}})',
        actionCancellationIssued: 'Factura de anulación emitida ({{num}})',
        actionInvoiceEmailed: 'Comprobante enviado por correo ({{num}} a {{to}})',
        actionInvoiceEmailFailed: 'Error al enviar el correo para {{num}}',
        cancelledToast: '¡Cita cancelada y correo enviado!',
        confirmedToast: '¡Cita confirmada y correo enviado!',
        statusUpdatedToast: 'Estado de la cita actualizado a {{status}}',
        updateError: 'No se pudo actualizar la cita',
        confirmDelete: '¿Está seguro de que desea eliminar esta cita?',
        deleteError: 'No se pudo eliminar la cita',
        intakeLinkCopied: 'Enlace del formulario de admisión copiado',
        intakeLinkCopyError: 'No se pudo copiar el enlace',
        statusPending: 'Pendiente',
        statusConfirmed: 'Confirmada',
        statusScheduled: 'Programada',
        statusCompleted: 'Completada',
        statusCancelled: 'Cancelada',
        statusNoShow: 'No asistió',
        title: 'Detalles de la cita',
        tabDetails: 'Detalles',
        tabIntake: 'Formulario de admisión',
        intakeSubmittedLabel: 'cumplimentado',
        tabHistory: 'Historial',
        intakeBannerTitle: 'Formulario de admisión para el paciente',
        intakeSubmittedBadge: '✓ Formulario cumplimentado',
        intakeWaitingBadge: 'Pendiente del paciente',
        intakeBannerText:
          'La cita está confirmada. La anamnesis es una obligación profesional — la cumplimentación digital previa es cómoda para el paciente y ahorra tiempo de espera el día del tratamiento.',
        copyLink: 'Copiar enlace',
        copied: '¡Copiado!',
        openForm: 'Abrir formulario',
        sendMailToPatient: 'Enviar correo al paciente →',
        websiteBannerTitle: 'Reserva online de seadent.es',
        websiteBannerPending:
          'El paciente ha reservado a través del formulario de reserva. Por favor, confirme o rechace.',
        websiteBannerOther: 'Esta reserva se originó a través del sitio web.',
        insuranceLabel: 'Seguro (indicado por el paciente):',
        patientInfo: 'Información del paciente',
        name: 'Nombre:',
        email: 'Correo electrónico:',
        phone: 'Teléfono:',
        appointmentDetails: 'Detalles de la cita',
        date: 'Fecha:',
        time: 'Hora:',
        provider: 'Doctor:',
        procedure: 'Tratamiento:',
        operatory: 'Sala:',
        status: 'Estado:',
        notes: 'Notas',
        googleCalendar: 'Google Calendar',
        viewInGoogleCalendar: 'Ver en Google Calendar',
        edit: 'Editar',
        completeAndInvoice: 'Finalizar y factura',
        createOffer: 'Crear presupuesto',
        createInvoice: 'Crear factura',
        acceptScheduled: 'Aceptar (→ Programada)',
        confirm: 'Confirmar',
        complete: 'Finalizar',
        cancel: 'Cancelar',
        noShow: 'No asistió',
        delete: 'Eliminar',
        loadingHistory: 'Cargando historial…',
        noHistory: 'No se encontró historial.',
        historyBy: 'por {{user}}',
      },
      form: {
        fillRequired: 'Por favor, rellene todos los campos obligatorios',
        patientNamePlaceholder: 'Max Mustermann',
        emailLabel: 'Correo electrónico *',
        emailPlaceholder: 'max@example.com',
        phoneLabel: 'Teléfono *',
        phonePlaceholder: '+34-612-345678',
        langEnglish: 'English',
        langGerman: 'Deutsch',
        langSpanish: 'Español',
        langRussian: 'Русский',
        selectProvider: 'Seleccionar doctor',
        selectProcedure: 'Seleccionar tratamiento',
        selectOperatory: 'Seleccionar sala',
        startTime: 'Hora de inicio *',
        endTime: 'Hora de fin *',
        googleCalendarTarget: '📅 Google Calendar para esta cita',
        mainCalendar: 'Calendario principal',
        defaultTag: '(Predeterminado)',
        previousCalendar: 'Calendario anterior',
        targetLockedHint:
          'ℹ️ La asignación de calendario no se puede cambiar después de la creación.',
        notesPlaceholder: 'Notas adicionales…',
        fallbackPrimaryLabel: 'Calendario anterior',
      },
    },
  },
};
